export default "\n<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n<app-footer></app-footer>";